import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import {useNavigate} from 'react-router-dom';
import useGetChat from '../../services/hookService/chats/getChat/useGetMyChats';
import useGetCheckContactLimit from '../../services/hookService/getCheckContactLimit/useGetCheckContactLimit';
import {format98To0} from '../../utilities/helper/formatPhoneNumber';
import {googleAnalyticsInstance} from '../../utilities/helper/googleAnalitics';
import DotsLoading from '../dotsLoading';
import {messageButtonData, Role} from './constants';

interface CustomMessageAreaProps {
  phoneNumber?: boolean;
  size?: 'md' | 'lg';
  productId?: string;
  isShop?: boolean;
  isLab?: boolean;
  shopNumber?: string;
  labNumber?: string;
  supplierGuid?: string;
}

const CustomMessageArea = ({
  phoneNumber,
  size = 'lg',
  productId = '',
  isShop = false,
  isLab = false,
  shopNumber,
  labNumber,
  supplierGuid,
}: CustomMessageAreaProps) => {
  const navigate = useNavigate();
  const {getChat, isLoading: isGetChatLoading} = useGetChat();
  const {data, isLoading, refetch} = useGetCheckContactLimit(productId, isShop);

  const role: Role = isShop ? 'shop' : isLab ? 'lab' : 'default';
  const recieverPhoneNumber = shopNumber || labNumber;

  const buttonData = messageButtonData[role];

  const handleChatClick = () => {
    if (!supplierGuid) return;
    getChat(supplierGuid, {
      onSuccess: data => {
        navigate(`/chat-form/${data?.guid}`, {state: {supplierGuid}});
      },
      onError: () => {
        navigate(`/chat-form/`, {state: {supplierGuid}});
      },
    });
  };

  const handlePhoneClick = () => {
    if (!isShop && !isLab) {
      refetch();
    }
  };

  const buttonClasses = classNames(
    'flex flex-1 justify-center items-center no-underline gap-1 border-[1px] rounded-[8px] text-sm',
    {
      'h-8': size === 'md',
      'h-12': size === 'lg',
    },
  );

  return (
    <div className="flex justify-between w-full gap-2">
      <button
        disabled={isGetChatLoading}
        onClick={handleChatClick}
        className={classNames(
          'flex flex-1 justify-center items-center bg-farm-shop-500 text-white rounded-[8px] text-sm border-[1px]',
          {'h-8': size === 'md', 'h-12': size === 'lg'},
        )}
      >
        {isGetChatLoading ? (
          <DotsLoading />
        ) : (
          <div
            className={classNames(
              buttonClasses,
              'text-farm-shop-200 border-farm-shop-200',
            )}
          >
            <SpanIcon className="text-2xl icon-namechat" />
            <span className="font-medium text-md">
              پیام به {buttonData?.roleName}
            </span>
          </div>
        )}
      </button>

      {!phoneNumber &&
        (data?.phone_number ? (
          <a
            href={`tel:${format98To0(data.phone_number)}`}
            onClick={() =>
              googleAnalyticsInstance.eventGoogleAnalytics({
                category: 'callToSeller',
                action: 'رو تماس با فروشنده در کارت خریداران کلیک شد',
              })
            }
            className={classNames(
              buttonClasses,
              'text-farm-shop-500 border-farm-shop-500',
            )}
          >
            <SpanIcon className="text-2xl icon-namecall" />
            <span className="font-medium text-md">نمایش تلفن خریدار</span>
          </a>
        ) : (
          <div
            className={classNames(
              buttonClasses,
              'text-farm-shop-500 border-farm-shop-500',
            )}
            onClick={handlePhoneClick}
          >
            {isLoading ? (
              <DotsLoading />
            ) : (
              <>
                <SpanIcon className="text-2xl icon-namecall" />
                <a
                  className="no-underline text-md text-farm-shop-500 hover:text-farm-shop-500"
                  href={`tel:${format98To0(recieverPhoneNumber as string)}`}
                  onClick={() =>
                    googleAnalyticsInstance.eventGoogleAnalytics({
                      category: buttonData?.actionCatagory as string,
                      action: `روی تماس با ${buttonData?.roleName} کلیک شد`,
                    })
                  }
                >
                  تماس با {buttonData?.roleName}
                </a>
              </>
            )}
          </div>
        ))}
    </div>
  );
};

export default CustomMessageArea;
